import * as React from 'react';
import { Color } from '../styles/constantStyles';

export interface IndicatorIconProps {
  color?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
}

export const IndicatorIcon = ({ color, width, height, style }: IndicatorIconProps) => (
  <svg style={style} width={width} height={height} viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 7L3.01142e-07 13.9282L9.06825e-07 0.0717964L12 7Z" fill={color || Color.MONOGREY3} />
  </svg>
);
